
<template>
  <b-row>
    <b-col>
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding:1rem "
          header="Historial Clinico" 
          :class="{ collapsed: !visibleBody }"
          data-toggle="collapse" 
          @click="() => visibleBody = !visibleBody"  
        >
          <span class="lead collapse-title">
            <strong>Historial Imágenes / Laboratorios</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 5px">
                                
            <HistorialImagenes 
              v-if="idPaciente"
              :idPaciente = "idPaciente"
            />
            
            <HistorialLabs 
              v-if = "idPaciente" 
              :idPaciente = "idPaciente"
            />
              
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

import HistorialImagenes from '@/views/atencionCita/components/HistorialData/HistorialImagenes.vue';
import HistorialLabs from '@/views/atencionCita/components/HistorialData/HistorialLabs.vue';

export default {

  name: "HistorialImagenesLabs",

  props: {
    idPaciente: String,
  },

  components: {
    HistorialImagenes,
    HistorialLabs
  },

  data() {
    return {
      visibleBody: false,
    }
  },
}
</script>

<style>

</style>